import React from "react";

const ModalWrapper = (props) => {
  return (
    <div
      className={`fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center ${
        props.zIndexClass ?? "z-40"
      }`}
    >
      <div
        className={`absolute inset-0 z-0 bg-full-black ${
          props.bgOpacity ? "opacity-" + props.bgOpacity : "opacity-40"
        }`}
        onClick={props.clickOff}
      />
      <div className="relative z-10">{props.children}</div>
    </div>
  );
};

export default ModalWrapper;
